import type { Game } from "@/domain/types";
import { deadlock } from "./deadlock/game";
import { destiny2 } from "./destiny/game";
import { sc2 } from "./sc2/game";

/** The built-in Games, keyed by id (mirrors keyboards/builtin). */
export const builtinGames: Record<string, Game> = {
  sc2,
  "destiny-2": destiny2,
  deadlock,
};

// Picker order. Deadlock is built (its data + tests live on in builtinGames above) but hidden from
// the picker: keylens can neither parse nor download a Deadlock setup yet (no .cfg parser, the
// Profiles are hand-authored), so it can't deliver the import/download value the other games do.
// Re-add "deadlock" here to unhide it once that lands.
export const gameOrder = ["sc2", "destiny-2"] as const;

/** The Game shown on load and the fallback for an unknown id. */
export const defaultGame: Game = sc2;
